module.exports = __webpack_public_path__ + "img/picture1.007325a2.webp";